import axios from '@axios'

export default {
  namespaced: true,
  state: {
    tabela_preco: {},
    cidades: [],
  },
  getters: {
    getCidades: state => state.cidades,
  },
  mutations: {
    SET_TABELA_PRECO(state, payload) {
      state.tabela_preco = payload
    },
  },
  actions: {
    findById({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/tabela-precos/${id}`)
          .then(response => {
            commit('SET_TABELA_PRECO', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    GET_CIDADES_BY_CIDADE_NOME({ commit }, uf) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/cidades?q=${uf}`)
          .then(response => {
            commit('SET_CIDADES', response.data.cidades)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
  },
}
